module.exports = __webpack_public_path__ + "img/linkedin-support.dbec0018.png";